import { useEffect, useId } from 'react';

// Module-level so sibling previews (insurance front/back, other forms) share one slot.
let activePreviewId: string | null = null;
const previewClosers = new Map<string, () => void>();

export default function useDocumentPreviewExclusive(open: boolean, onClose: () => void) {
  const previewId = useId();

  useEffect(() => {
    previewClosers.set(previewId, onClose);

    if (open) {
      if (activePreviewId != null && activePreviewId !== previewId) {
        previewClosers.get(activePreviewId)?.();
      }
      activePreviewId = previewId;
    } else if (activePreviewId === previewId) {
      activePreviewId = null;
    }

    return () => {
      previewClosers.delete(previewId);
      if (activePreviewId === previewId) {
        activePreviewId = null;
      }
    };
  }, [onClose, open, previewId]);
}
